// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 파일명: AppNoticeManage.css */

.notice-manage {
    width: 100%;
}

.notice-title {
    color: white;
    margin-bottom: 20px;
}

/* 등록 폼 */
.notice-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 24px;
}

.notice-input {
    width: 100%;
    height: 44px;
    padding: 0 14px;
    border-radius: 10px;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(255,255,255,0.04);
    color: white;
    font-size: 14px;
}

.notice-textarea {
    width: 100%;
    min-height: 100px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(255,255,255,0.04);
    color: white;
    font-size: 14px;
    resize: vertical;
}

.notice-save-button {
    align-self: flex-end;
    height: 40px;
    padding: 0 18px;
    border: none;
    border-radius: 999px;
    background: linear-gradient(135deg,#7c3aed,#0ea5e9);
    color: white;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
}

.notice-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.notice-card {
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 14px;
    padding: 14px 16px;
    background: rgba(255,255,255,0.03);
}

.notice-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 6px;
}

.notice-item-title {
    margin: 0;
    color: white;
    font-size: 15px;
}

.notice-date {
    font-size: 11px;
    color: rgba(255,255,255,0.45);
    white-space: nowrap;
}

.notice-content {
    margin: 0 0 10px;
    font-size: 13px;
    color: rgba(255,255,255,0.8);
    white-space: pre-wrap;
    word-break: break-word;
}

.notice-actions {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
}

.notice-edit-button,
.notice-delete-button {
    border: none;
    border-radius: 999px;
    padding: 6px 12px;
    font-size: 12px;
  color: white;
  cursor: pointer;
}

.notice-edit-button {
  background: #2196f3;
}

.notice-delete-button {
  background: #ef5350;
}

/* 모달 */
.notice-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 900;
}

.notice-modal-box {
    width: 90%;
    max-width: 520px;
    border-radius: 18px;
    padding: 20px;
    background: rgba(20,20,20,0.98);
    border: 1px solid rgba(255,255,255,0.06);
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.notice-modal-title {
    color: white;
    margin: 0;
}

.notice-modal-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.notice-cancel-button {
    border: none;
    border-radius: 999px;
    padding: 6px 14px;
    font-size: 12px;
  background: #bdbdbd;
  color: #222;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/AppNoticeManage.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,wCAAwC;IACxC,kCAAkC;IAClC,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,kCAAkC;IAClC,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,mDAAmD;IACnD,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,OAAO;AACP;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;EACjB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* 파일명: AppNoticeManage.css */\n\n.notice-manage {\n    width: 100%;\n}\n\n.notice-title {\n    color: white;\n    margin-bottom: 20px;\n}\n\n/* 등록 폼 */\n.notice-form {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 24px;\n}\n\n.notice-input {\n    width: 100%;\n    height: 44px;\n    padding: 0 14px;\n    border-radius: 10px;\n    border: 1px solid rgba(255,255,255,0.08);\n    background: rgba(255,255,255,0.04);\n    color: white;\n    font-size: 14px;\n}\n\n.notice-textarea {\n    width: 100%;\n    min-height: 100px;\n    padding: 10px 14px;\n    border-radius: 10px;\n    border: 1px solid rgba(255,255,255,0.08);\n    background: rgba(255,255,255,0.04);\n    color: white;\n    font-size: 14px;\n    resize: vertical;\n}\n\n.notice-save-button {\n    align-self: flex-end;\n    height: 40px;\n    padding: 0 18px;\n    border: none;\n    border-radius: 999px;\n    background: linear-gradient(135deg,#7c3aed,#0ea5e9);\n    color: white;\n    font-size: 13px;\n    font-weight: 700;\n    cursor: pointer;\n}\n\n.notice-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.notice-card {\n    border: 1px solid rgba(255,255,255,0.06);\n    border-radius: 14px;\n    padding: 14px 16px;\n    background: rgba(255,255,255,0.03);\n}\n\n.notice-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 10px;\n    margin-bottom: 6px;\n}\n\n.notice-item-title {\n    margin: 0;\n    color: white;\n    font-size: 15px;\n}\n\n.notice-date {\n    font-size: 11px;\n    color: rgba(255,255,255,0.45);\n    white-space: nowrap;\n}\n\n.notice-content {\n    margin: 0 0 10px;\n    font-size: 13px;\n    color: rgba(255,255,255,0.8);\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n.notice-actions {\n    display: flex;\n    gap: 8px;\n    justify-content: flex-end;\n}\n\n.notice-edit-button,\n.notice-delete-button {\n    border: none;\n    border-radius: 999px;\n    padding: 6px 12px;\n    font-size: 12px;\n  color: white;\n  cursor: pointer;\n}\n\n.notice-edit-button {\n  background: #2196f3;\n}\n\n.notice-delete-button {\n  background: #ef5350;\n}\n\n/* 모달 */\n.notice-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0,0,0,0.75);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 900;\n}\n\n.notice-modal-box {\n    width: 90%;\n    max-width: 520px;\n    border-radius: 18px;\n    padding: 20px;\n    background: rgba(20,20,20,0.98);\n    border: 1px solid rgba(255,255,255,0.06);\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.notice-modal-title {\n    color: white;\n    margin: 0;\n}\n\n.notice-modal-buttons {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n}\n\n.notice-cancel-button {\n    border: none;\n    border-radius: 999px;\n    padding: 6px 14px;\n    font-size: 12px;\n  background: #bdbdbd;\n  color: #222;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
